import { render, staticRenderFns } from "./news_interview.vue?vue&type=template&id=30f13645"
import script from "./news_interview.vue?vue&type=script&lang=js"
export * from "./news_interview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports